import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { ProfessionalUnavailabilityService } from '../professional-unavailability.service';

export const useCreateProfessionalUnavailability = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createClinicMutation = useMutation({
		mutationFn: (body: ProfessionalUnavailabilitys.Create) =>
			ProfessionalUnavailabilityService.create(body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['professionalUnavailabilitys'],
			});
			toast.success('Indisponibilidade criada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro na criação da indisponibilidade'),
			);
		},
	});

	return createClinicMutation;
};

export const useDeleteUnavailableDate = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const deleteUnavailableMutation = useMutation({
		mutationFn: (id: string) =>
			ProfessionalUnavailabilityService.destroy(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['professional-unavailability'],
			});
			toast.success('Indisponibilidade deletada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro no delete da indisponibilidade'),
			);
		},
	});

	return deleteUnavailableMutation;
};

export const useUpdateUnavailableDate = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const updateUnavailableMutation = useMutation({
		mutationFn: (
			data: ProfessionalUnavailabilitys.ProfessionalUnavailability,
		) => ProfessionalUnavailabilityService.patch(data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['professional-unavailability'],
			});
			toast.success('Indisponilidade atualizada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(
					error,
					'Erro na atualização da indisponibilidade',
				),
			);
		},
	});

	return updateUnavailableMutation;
};
